module.exports = __webpack_public_path__ + "images/emails/signatures/katrina-6e1d45a81278392a0fd6335183c99aa2.jpg";